__turbopack_context__.v({
  "active": "checkout-module-scss-module__ili6Fq__active",
  "addressBlock": "checkout-module-scss-module__ili6Fq__addressBlock",
  "audPriceMessage": "checkout-module-scss-module__ili6Fq__audPriceMessage",
  "bag-empty": "checkout-module-scss-module__ili6Fq__bag-empty",
  "bagAddList": "checkout-module-scss-module__ili6Fq__bagAddList",
  "bagEmptyBlock": "checkout-module-scss-module__ili6Fq__bagEmptyBlock",
  "bagsHd": "checkout-module-scss-module__ili6Fq__bagsHd",
  "bagsItemEdit": "checkout-module-scss-module__ili6Fq__bagsItemEdit",
  "bagsItemImg": "checkout-module-scss-module__ili6Fq__bagsItemImg",
  "bagsItemInfo": "checkout-module-scss-module__ili6Fq__bagsItemInfo",
  "bagsItemInst": "checkout-module-scss-module__ili6Fq__bagsItemInst",
  "bagsItemOuter": "checkout-module-scss-module__ili6Fq__bagsItemOuter",
  "bagsItemPrice": "checkout-module-scss-module__ili6Fq__bagsItemPrice",
  "bagsItemRemove": "checkout-module-scss-module__ili6Fq__bagsItemRemove",
  "bagsItemSubtitle": "checkout-module-scss-module__ili6Fq__bagsItemSubtitle",
  "bagsItemTitle": "checkout-module-scss-module__ili6Fq__bagsItemTitle",
  "bottomGap": "checkout-module-scss-module__ili6Fq__bottomGap",
  "btnCustom": "checkout-module-scss-module__ili6Fq__btnCustom",
  "cardElementInput": "checkout-module-scss-module__ili6Fq__cardElementInput",
  "causeImg": "checkout-module-scss-module__ili6Fq__causeImg",
  "changeTp": "checkout-module-scss-module__ili6Fq__changeTp",
  "checkBox": "checkout-module-scss-module__ili6Fq__checkBox",
  "checkmark": "checkout-module-scss-module__ili6Fq__checkmark",
  "checkoutBlock": "checkout-module-scss-module__ili6Fq__checkoutBlock",
  "checkoutRadio": "checkout-module-scss-module__ili6Fq__checkoutRadio",
  "closeBtn": "checkout-module-scss-module__ili6Fq__closeBtn",
  "colorOrange": "checkout-module-scss-module__ili6Fq__colorOrange",
  "cupponBlock": "checkout-module-scss-module__ili6Fq__cupponBlock",
  "cupponMessage": "checkout-module-scss-module__ili6Fq__cupponMessage",
  "dayHd": "checkout-module-scss-module__ili6Fq__dayHd",
  "deliverFormBlock": "checkout-module-scss-module__ili6Fq__deliverFormBlock",
  "deliverInfoBlock": "checkout-module-scss-module__ili6Fq__deliverInfoBlock",
  "deliverTab": "checkout-module-scss-module__ili6Fq__deliverTab",
  "deliveryHeading": "checkout-module-scss-module__ili6Fq__deliveryHeading",
  "deliveryOption": "checkout-module-scss-module__ili6Fq__deliveryOption",
  "deliveryOptions": "checkout-module-scss-module__ili6Fq__deliveryOptions",
  "destinationHd": "checkout-module-scss-module__ili6Fq__destinationHd",
  "detailBlock": "checkout-module-scss-module__ili6Fq__detailBlock",
  "displayAdd": "checkout-module-scss-module__ili6Fq__displayAdd",
  "editBtn": "checkout-module-scss-module__ili6Fq__editBtn",
  "editIcon": "checkout-module-scss-module__ili6Fq__editIcon",
  "editPayment": "checkout-module-scss-module__ili6Fq__editPayment",
  "error": "checkout-module-scss-module__ili6Fq__error",
  "exp": "checkout-module-scss-module__ili6Fq__exp",
  "formControl": "checkout-module-scss-module__ili6Fq__formControl",
  "formGroup": "checkout-module-scss-module__ili6Fq__formGroup",
  "groupPosition": "checkout-module-scss-module__ili6Fq__groupPosition",
  "gstText": "checkout-module-scss-module__ili6Fq__gstText",
  "guestBox": "checkout-module-scss-module__ili6Fq__guestBox",
  "guestBtn": "checkout-module-scss-module__ili6Fq__guestBtn",
  "guestCheckoutInfo": "checkout-module-scss-module__ili6Fq__guestCheckoutInfo",
  "guestNews": "checkout-module-scss-module__ili6Fq__guestNews",
  "guestUser": "checkout-module-scss-module__ili6Fq__guestUser",
  "linkClick": "checkout-module-scss-module__ili6Fq__linkClick",
  "loaderPosition": "checkout-module-scss-module__ili6Fq__loaderPosition",
  "loginMsg": "checkout-module-scss-module__ili6Fq__loginMsg",
  "mainBagBlock": "checkout-module-scss-module__ili6Fq__mainBagBlock",
  "mainDeliveryBlock": "checkout-module-scss-module__ili6Fq__mainDeliveryBlock",
  "mainLeftBlock": "checkout-module-scss-module__ili6Fq__mainLeftBlock",
  "messageAbove": "checkout-module-scss-module__ili6Fq__messageAbove",
  "messageBelow": "checkout-module-scss-module__ili6Fq__messageBelow",
  "mgTop10": "checkout-module-scss-module__ili6Fq__mgTop10",
  "msgInfoBlock": "checkout-module-scss-module__ili6Fq__msgInfoBlock",
  "myAccountLink": "checkout-module-scss-module__ili6Fq__myAccountLink",
  "orderTotal": "checkout-module-scss-module__ili6Fq__orderTotal",
  "outerOverlay": "checkout-module-scss-module__ili6Fq__outerOverlay",
  "overlay": "checkout-module-scss-module__ili6Fq__overlay",
  "paymentCardBox": "checkout-module-scss-module__ili6Fq__paymentCardBox",
  "paymentDetailsBlock": "checkout-module-scss-module__ili6Fq__paymentDetailsBlock",
  "paymentDetailsCart": "checkout-module-scss-module__ili6Fq__paymentDetailsCart",
  "paymentDetailsForm": "checkout-module-scss-module__ili6Fq__paymentDetailsForm",
  "paymentSubtotalList": "checkout-module-scss-module__ili6Fq__paymentSubtotalList",
  "paymentTotalList": "checkout-module-scss-module__ili6Fq__paymentTotalList",
  "paymentVia": "checkout-module-scss-module__ili6Fq__paymentVia",
  "paymentViaSelect": "checkout-module-scss-module__ili6Fq__paymentViaSelect",
  "placeOrder": "checkout-module-scss-module__ili6Fq__placeOrder",
  "placeOrderGray": "checkout-module-scss-module__ili6Fq__placeOrderGray",
  "placeOrderHelp": "checkout-module-scss-module__ili6Fq__placeOrderHelp",
  "placeOrderLinks": "checkout-module-scss-module__ili6Fq__placeOrderLinks",
  "placeOrderSpan": "checkout-module-scss-module__ili6Fq__placeOrderSpan",
  "positionRel": "checkout-module-scss-module__ili6Fq__positionRel",
  "promoBlock": "checkout-module-scss-module__ili6Fq__promoBlock",
  "promoCode": "checkout-module-scss-module__ili6Fq__promoCode",
  "radioFree": "checkout-module-scss-module__ili6Fq__radioFree",
  "radioHd": "checkout-module-scss-module__ili6Fq__radioHd",
  "radioInfo": "checkout-module-scss-module__ili6Fq__radioInfo",
  "recipientAddress": "checkout-module-scss-module__ili6Fq__recipientAddress",
  "recipientTp": "checkout-module-scss-module__ili6Fq__recipientTp",
  "remindMeButton": "checkout-module-scss-module__ili6Fq__remindMeButton",
  "shippingMessage": "checkout-module-scss-module__ili6Fq__shippingMessage",
  "shippingOp": "checkout-module-scss-module__ili6Fq__shippingOp",
  "shippingOptions": "checkout-module-scss-module__ili6Fq__shippingOptions",
  "stripeMessage": "checkout-module-scss-module__ili6Fq__stripeMessage",
  "success": "checkout-module-scss-module__ili6Fq__success",
  "yourBagBlock": "checkout-module-scss-module__ili6Fq__yourBagBlock",
  "yourCauseBlock": "checkout-module-scss-module__ili6Fq__yourCauseBlock",
});
